<template>
  <div id="app">
    <b-card>
      <b-card-header>
        <b-card-title>Unconverted Leads and Opportunity Cost</b-card-title>
      </b-card-header>
      
      <!-- Table Section -->
      <b-table
        :items="data"
        :fields="fields"
        striped
        hover
        responsive
        class="mb-4"
      >
        <template #cell(totalEstimateValue)="data">
          ${{ formatCurrency(data.value) }}
        </template>
      </b-table>

      <!-- Chart Section -->
      <apexchart
        type="bar"
        :height="350"
        :options="chartOptions"
        :series="series"
      />
    </b-card>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import { BCard, BCardTitle, BCardHeader, BTable } from "bootstrap-vue";

export default {
  name: "LeadClientOpportunityChart",
  components: {
    apexchart: VueApexCharts,
    BCard,
    BCardHeader,
    BCardTitle,
    BTable
  },
  props: {
    data: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  computed: {
    fields() {
      return [
        { key: 'name', label: 'Lead Name', sortable: true },
        { 
          key: 'totalEstimateValue', 
          label: 'Expected Revenue', 
          sortable: true,
          class: 'text-right'
        }
      ];
    },
    totalOpportunityCost() {
      return this.data.reduce((sum, lead) => sum + lead.totalEstimateValue, 0);
    },
    series() {
      return [{
        name: "Total Expected Revenue",
        data: [this.totalOpportunityCost]
      }];
    },
    chartOptions() {
      return {
        chart: {
          height: 350,
          type: 'bar',
        },
        plotOptions: {
          bar: {
            columnWidth: '45%',
            distributed: true,
            borderRadius: 4,
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function(val) {
            return '$' + val.toLocaleString();
          }
        },
        xaxis: {
          categories: ['Total Opportunity Cost'],
          labels: {
            style: {
              fontSize: '14px'
            }
          }
        },
        yaxis: {
          title: {
            text: 'Expected Revenue ($)',
          },
          labels: {
            formatter: function(val) {
              return '$' + val.toLocaleString();
            }
          }
        },
        colors: ['#2E7D32'],
        title: {
          text: 'Total Expected Revenue from Unconverted Leads',
          align: 'center',
          style: {
            fontSize: '16px'
          }
        }
      };
    }
  },
  methods: {
    formatCurrency(value) {
      return value.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }
  }
};
</script>

<style scoped>
#app {
  width: 100%;
  height: 100%;
  margin: 20px;
}

@media (max-width: 768px) {
  #app {
    margin: 10px;
  }
}
</style>